export default () => {
  const els = document.querySelectorAll('[data-animate-on-enter]');

  if (els.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          entry.target.classList.remove('opacity-0');
        }
      });
    });

    els.forEach((el) => {
      el.classList.add('opacity-0');
      observer.observe(el);
    });
  }
};
